export var HeaderDictionaryEn = {
  welcomeMessage: 'Welcome, {{office_name}}',
  lastLogin: 'Last Login, {{last_login}}'
};